import { LightningElement,api} from "lwc";
import { ListItem } from "./types";
export type { ListItem };

export default class ClassSession extends LightningElement {
  static renderMode = "light";
  @api listitem: ListItem | null = null;
  
  @api buttonDetailWes={
    id: "1",
    buttonLabel: {
        value: "",
        label: ""
    },
    variant: '',
    size: 'default',
    showWesButton: true
  };

  registerHandler() {
    this.dispatchEventMethod("register",{ classId: this.listitem!.id, name: this.buttonDetailWes.buttonLabel.value, registerFlag : this.listitem!.registerFlag });
  }
  
  dispatchEventMethod(eventName: string, eventDetail: { classId: string, name: string ,registerFlag: string}){
    this.dispatchEvent(
        new CustomEvent(eventName, {
          detail: eventDetail,
        })
    );
  }

  private get showDiscount() {
    return this.listitem!.discountAmount > 0;
  }

  private get showLearningCredit() {
    return this.listitem!.learningCredits !== "" ? true : false;
  }

  private get strikeThroughText() {
    return this.listitem!.discountAmount > 0 ? "text-decoration: line-through;color: gray" : "";
  }

  private get blackTextColor() {
    return this.listitem!.discountAmount > 0 ? "color: #000000;" : "";
  }

  private get showInperson() {
    return this.listitem?.badgeText !== "Virtual" ? true : false;
  }

  private get showVirtual() {
    return this.listitem?.badgeText === "Virtual" ? true : false;
  } 

  private get showConvertedTime() {
    return this.listitem?.convertedTime !== "" ? true : false;
  }

  private get isDisabled() {
    return ["Prospecting","Registered", "AddedToCart"].includes(this.listitem!.registerFlag) === true ? true : false;
  }

  private get showBrandButton() {
    let isBrandButton=["Waitlist", "Register","ATP_Interest","Unavailable","Prospecting"].includes(this.listitem!.registerFlag);
    if(isBrandButton){
   
      this.buttonDetailWes.variant = "primary";
    }
    return isBrandButton;
  }

  private get showIconButton() {
    let isIconButton=["Registered", "AddedToCart"].includes(this.listitem!.registerFlag)
     if(isIconButton){
       this.buttonDetailWes.variant = "primary";
     }
     return isIconButton;
   }

  private get showBorderButton() {
    let isBorderButton=["Waitlisted"].includes(this.listitem!.registerFlag);
    if(isBorderButton){
      this.buttonDetailWes.variant = "secondary";
    }
    return isBorderButton;
  }

  connectedCallback(): void {
    this.createButtonData();
  }
  
  createButtonData(){
    

    if(["Waitlist"].includes(this.listitem!.registerFlag)){
      let buttonObject = this.listitem!.buttonArr.find(btn => btn.value === 'join_waitlist');
      this.setButtonData(String(buttonObject?.label),String(buttonObject?.value));
    }
    if([ "Register","ATP_Interest","Unavailable"].includes(this.listitem!.registerFlag)){
      let buttonObject = this.listitem!.buttonArr.find(btn => btn.value === 'register_now');
      this.setButtonData(String(buttonObject?.label),String(buttonObject?.value));
    }
    if(["Registered"].includes(this.listitem!.registerFlag)){
      let buttonObject = this.listitem!.buttonArr.find(btn => btn.value === 'registered');
      this.setButtonData(String(buttonObject?.label),String(buttonObject?.value));
    }
    if(["AddedToCart"].includes(this.listitem!.registerFlag)){
      let buttonObject = this.listitem!.buttonArr.find(btn => btn.value === 'added_to_cart');
      this.setButtonData(String(buttonObject?.label),String(buttonObject?.value));
    }
    if(["Waitlisted"].includes(this.listitem!.registerFlag)){
      let buttonObject = this.listitem!.buttonArr.find(btn => btn.value === 'cancel_waitlist');
      this.setButtonData(String(buttonObject?.label),String(buttonObject?.value));
    }
    if(["Prospecting"].includes(this.listitem!.registerFlag)){
      let buttonObject = this.listitem!.buttonArr.find(btn => btn.value === 'interest_submitted');
      this.setButtonData(String(buttonObject?.label),String(buttonObject?.value));
    }
  }

  setButtonData(buttonLabel : string, buttonValue : string){
    this.buttonDetailWes.buttonLabel.label=buttonLabel;
    this.buttonDetailWes.buttonLabel.value=buttonValue;
  }
}